module.exports = __webpack_public_path__ + "img/thumbnail_RedDeer_m_normal.068da097.png";